import './accessibility.css';
export default {
  "hidden": "pf-v6-u-hidden",
  "hiddenOnLg": "pf-v6-u-hidden-on-lg",
  "hiddenOnMd": "pf-v6-u-hidden-on-md",
  "hiddenOnSm": "pf-v6-u-hidden-on-sm",
  "hiddenOnXl": "pf-v6-u-hidden-on-xl",
  "hiddenOn_2xl": "pf-v6-u-hidden-on-2xl",
  "screenReader": "pf-v6-u-screen-reader",
  "screenReaderOnLg": "pf-v6-u-screen-reader-on-lg",
  "screenReaderOnMd": "pf-v6-u-screen-reader-on-md",
  "screenReaderOnSm": "pf-v6-u-screen-reader-on-sm",
  "screenReaderOnXl": "pf-v6-u-screen-reader-on-xl",
  "screenReaderOn_2xl": "pf-v6-u-screen-reader-on-2xl",
  "visible": "pf-v6-u-visible",
  "visibleOnLg": "pf-v6-u-visible-on-lg",
  "visibleOnMd": "pf-v6-u-visible-on-md",
  "visibleOnSm": "pf-v6-u-visible-on-sm",
  "visibleOnXl": "pf-v6-u-visible-on-xl",
  "visibleOn_2xl": "pf-v6-u-visible-on-2xl"
};